import axiosInstance from '../../config/axios';
import type { APIResp } from '../../types/APIService';
import type { ColorGroup } from '../../types/DentalMaterial';

export async function getAllColorGroups(): Promise<ColorGroup[]> {
  try {
    const res = await axiosInstance.get<APIResp<ColorGroup[]>>('/color_groups');
    return res.data.data.map(group => ({ ...group, colors: group.colors.map(clr => clr.trim()) })); // Fix possible space like 'A1' vs ' A1'
  }
  catch {
    return [];
  }
}

export async function postColorGroup(body: Omit<ColorGroup, 'id' | 'created_at'>) {
  try {
    await axiosInstance.post('/color_groups', body);
    return true;
  }
  catch {
    return false;
  }
}

export async function updateColorGroup({ id, ...body }: ColorGroup) {
  try {
    await axiosInstance.put(`/color_groups/${id}`, body);
    return true;
  }
  catch {
    return false;
  }
}

export async function deleteColorGroup(id: number) {
  try {
    await axiosInstance.delete(`/color_groups/${id}`);
    return true;
  }
  catch {
    return false;
  }
}
